// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, DEVICE_TYPE, MARGIN } from "../../constants/variables";

export const AlertCard = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${MARGIN.max24};
  cursor: pointer;
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    width: 90%;
  }
  @media (max-width: 1300px) {
    width: 100%;
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    flex-direction: column;
    gap: ${MARGIN.fix16};
  }
`;

export const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: ${COLORS.Yellow};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: ${COLORS.Crimson};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.img``;

export const InfoContainer = styled.div`
  margin-left: ${MARGIN.max20};
  gap: ${MARGIN.max8};
  display: flex;
  flex-direction: column;
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    justify-content: center;
    align-items: center;
  }
`;

export const BodyWrapper = styled.div`
  max-width: 437px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${MARGIN.max8};
`;
